module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dia_container dia_conf_edit"
  }, [_c('div', {
    staticClass: "cl title"
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-content"
  }, [_c('div', {
    staticClass: "group-container"
  }, [_c('el-transfer', {
    attrs: {
      "titles": ['待选资源组', '已选资源组'],
      "props": _vm.transferProps,
      "data": _vm.groupList
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dia_btn_container"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c7e82fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7e82fa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/packageConfig/configGroup.vue
// module id = 260
// module chunks = 0